/* eslint-disable jsdoc/require-example */
import {axaStore} from 'Store/index';
import {NAVIGATION_REDUCER} from 'Store/reducer';
import AjaxUrlHtml from 'Components/AjaxUrlHtml/AjaxUrlHtml';

const ID_CUSTOMER = 'ic';

/**
 * @description Get the ajax info from the data-ajax-url-client & data-ajax-url-prospect attributes,
 *  and inject the response form tha call into the target.
 */
export default class AjaxUrlHtmlClientProspect extends AjaxUrlHtml {
    /**
     * @description We get the info from
     * the domElement and it's also the target.
     * @param {HTMLElement} domElement - Target of injection with ajax info.
     */
    constructor(domElement) {
        super(domElement);
        this.init();
    }

    /**
     * @description Init the module and get the template.
     */
    init() {
        const {url} = AjaxUrlHtml.getDOMElementProps(this.domElement);
        const unsubscribe = axaStore.subscribe(() => {
            const {isConnected} = axaStore.getState()[NAVIGATION_REDUCER].client;
            const result = new RegExp(`${ID_CUSTOMER}=[^;]+`).exec(document.cookie);
            const icValue = decodeURIComponent(result ? result.toString().replace(/^[^=]+./, '') : '');
            if(isConnected || icValue) {
                AjaxUrlHtml.getTemplate(url)
                    .then(tpl => AjaxUrlHtml.replaceContent(tpl, this.domElement));
                unsubscribe();
            }
        });
    }
}
